export { default } from "./FrequentQuestions";
